import { authorizedAxios } from "../../../Actions/AxiosActions";
import { IGetBrandsSampleSetDataByClosestRequest } from "../../../Models/Requests/IGetBrandsSampleSetDataByClosestRequest";
import { IGetBrandsSampleSetDataByGeoRequest } from "../../../Models/Requests/IGetBrandsSampleSetDataByGeoRequest";

export async function getBrands() {
    try {
        return await authorizedAxios("GET", "/services/gps/Brand/", null, null);
    } catch (error) {
        throw error;
    }
}

export async function getBrandSampleSetLocationsByGeo(
    request: IGetBrandsSampleSetDataByGeoRequest
) {
    try {
        return await authorizedAxios(
            "POST",
            "/services/gps/RetailMatch/GetSampleSetByGeo",
            null,
            request
        );
    } catch (error) {
        throw error;
    }
}

export async function getBrandSampleSetLocationsByClosest(
    request: IGetBrandsSampleSetDataByClosestRequest
) {
    try {
        return await authorizedAxios(
            "POST",
            "/services/gps/RetailMatch/GetSampleSetLocations",
            null,
            request
        );
    } catch (error) {
        throw error;
    }
}
